// project imports
import LogoSimple from './LogoSimple';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return <LogoSimple titleAccess="Swift Soft" sx={{ fontSize: 35, width: 35, height: 35 }} />;
}